import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { LoginRequest } from '../../domain/requests';
import { AccountRepository } from '../../repositories';
import { Authorize } from "../../domain/models";
@Injectable({ providedIn: 'root' })
export class LoginUsecase implements UseCase<LoginRequest, Authorize> {
  constructor(private accountRepository: AccountRepository) {}

  execute(params: LoginRequest): Observable<Authorize> {
    return this.accountRepository.login(params);
  }
}
